<template>
    <div>
        <el-row>
            <h2>订单管理</h2>
        </el-row>
        <el-row>
            <el-col>
                <el-form :inline="true" class="demo-form-inline" style="padding-top:0;margin-top:0" :model="searchForm"
                         ref="searchForm">
                    <el-form-item label="项目点：">
                        <el-input v-model="searchForm.PROJECT"></el-input>
                    </el-form-item>
                    <el-form-item label="档口：">
                        <el-input v-model="searchForm.DK"></el-input>
                    </el-form-item>
                    <el-form-item label="供应商：">
                        <el-input v-model="searchForm.SUPPLIER"></el-input>
                    </el-form-item>
                    <el-form-item label="送货时间：">
                        <el-date-picker
                                v-model="searchForm.SEND_DAY"
                                type="date"
                                placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="search">筛选</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="2">
                <el-button @click="addProduct" style="margin-bottom: 20px">添加商品</el-button>
            </el-col>
            <el-col :span="2">
                <el-button @click="editCount" style="margin-bottom: 20px">修改实收数量</el-button>
            </el-col>
            <el-col :span="2">
                <el-button @click="deleteOrder" style="margin-bottom: 20px">废除订单</el-button>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-table :data="orderData" border stripe style="width: 100%">
                    <el-table-column type="index" label="序号" width="50" min-width="30"></el-table-column>
                    <el-table-column prop="NAME" label="产品名称" width="150"></el-table-column>
                    <el-table-column label="订单数量" width="150">
                        <template slot-scope="scope">
                            <el-input type="text" v-model="orderData[scope.$index].PRODUCT_COUNT"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="实收数量" min-width="150">
                        <template slot-scope="scope">
                            <el-input type="text" v-model="orderData[scope.$index].REAL_COUNT"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="项目点价格" min-width="150">
                        <template slot-scope="scope">
                            <el-input type="text" v-model="orderData[scope.$index].PROJECT_PRICE"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="供应商价格" min-width="100">
                        <template slot-scope="scope">
                            <el-input type="text" v-model="orderData[scope.$index].REAL_PRICE"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column
                            fixed="right"
                            label="操作"
                            width="290">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" icon="el-icon-close" style="color:red" @click="stop(scope.row)">删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="2" :offset="22">
                <el-button @click="submit" style="margin-top: 20px">提交</el-button>
            </el-col>
        </el-row>
        <el-dialog title="新增产品" center :visible.sync="addFormVisible" width="600px" @close="resetContent('addForm')" :close-on-click-modal="false">
            <el-form :model="addForm" ref="addForm" >
                <el-form-item label="产品编码：" :label-width="formLabelWidth">
                    <el-input v-model="addForm.CODE"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="resetContent()">取 消</el-button>
                <el-button @click="submitAdd()">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="exportCountDialog" title="导入报价" @close="closeCount" width="400px" center :close-on-click-modal="false">
            <el-form ref="editForm" v-model="editForm">
                <el-upload
                        class="upload-demo"
                        action="/uploadFile"
                        :on-success="handleSuccess"
                        :name="this.editForm.REAL_COUNT"
                        multiple
                        :limit = "1"
                        accept=".xls,.xlsx"
                        :file-list="fileList">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过500kb</div>
                </el-upload>
            </el-form>
            <div slot="footer" style="text-align: center;">
                <el-button class="operate-btn" @click="closeCount">取消</el-button>
                <el-button class="operate-btn" @click="handleExportCount">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import http from '@/api/base/http';
import date from '@/common/date';

export default {
  data() {
    return {
      // loading: false,
      searchForm: {
        PROJECT_CODE: '',
        DK_CODE: '',
        SUPPLIER_CODE: '',
      },
      orderData: [],
      addForm: {

      },
      addFormVisible: false,
      formLabelWidth: '100px',
      orderID: '',
      exportCountDialog: false,
      editForm: {
        REAL_COUNT: 'tmp',
      },
      fileList: [],
      file_name: '',
    };
  },
  methods: {
    submit() {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const confirmArray = [];
          this.orderData.forEach((item) => {
            confirmArray.push({
              DETAIL_ID: item.DETAIL_ID, PRODUCT_CODE: item.PRODUCT_CODE, PRODUCT_COUNT: item.PRODUCT_COUNT, REAL_COUNT: item.REAL_COUNT, PROJECT_PRICE: item.PROJECT_PRICE, REAL_PRICE: item.REAL_PRICE,
            });
          });
          const params = {
            SERVICE_ID: '11000',
            OTYPE: 3,
            ORDER_ID: this.orderID,
            PRODUCT_ARRAY: confirmArray,
          };
          http.post(params).then((result) => {
            this.$message.show({ text: '成功', type: 'success' });
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
    addProduct() {
      this.addFormVisible = true;
    },
    submitAdd() {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '11000',
            OTYPE: 4,
            ORDER_ID: this.orderID,
            PRODUCT_CODE: this.addForm.CODE,
            TC_ID: sessionStorage.getItem('companyId'),
          };
          http.post(params).then((result) => {
            this.$message.show({ text: '成功', type: 'success' });
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
    resetContent() {
      this.addFormVisible = false;
      this.addForm = {};
    },
    stop(row) {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '11000',
            OTYPE: 2,
            DETAIL_ID: row.DETAIL_ID,
            TC_ID: sessionStorage.getItem('companyId'),
          };
          http.post(params).then((result) => {
            this.$message.show({ text: '成功', type: 'success' });
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
    search() {
      const params = {
        SERVICE_ID: '11000',
        OTYPE: 1,
        PROJECT_CODE: this.searchForm.PROJECT,
        DK_CODE: this.searchForm.DK,
        SUPPLIER_CODE: this.searchForm.SUPPLIER,
        SEND_DAY: date(this.searchForm.SEND_DAY, '%F'),
        TC_ID: sessionStorage.getItem('companyId'),
      };
      http.post(params).then((result) => {
        if (result[0].DATA.length != 0) {
          this.orderData = result[0].DATA;
          this.orderID = result[0].ORDER_ID;
        } else {
          this.orderData = [];
          this.orderID = result[0].ORDER_ID;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    editCount() {
      this.exportCountDialog = true;
    },
    closeCount() {
      this.exportCountDialog = false;
    },
    handleSuccess(response, file, fileList) {
      this.file_name = response.file_name;
    },
    handleExportCount() {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '11000',
            OTYPE: 5,
            TC_ID: Number(sessionStorage.getItem('companyId')),
            FILE_NAME: this.file_name,
          };
          // this.loading = true
          http.post(params)
            .then((result) => {
              this.$message.show({ text: '导入成功', type: 'success' });
              this.exportCountDialog = false;
              // this.loading = false
              document.body.style.cursor = 'default';
            })
            .catch((error) => {
              this.$message.show({ text: error, type: 'error' });
              // this.loading = false
              document.body.style.cursor = 'default';
            });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
    deleteOrder() {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '11000',
            OTYPE: 6,
            ORDER_ID: this.orderID,
          };
          http.post(params).then((result) => {
            this.$message.show({ text: '成功', type: 'success' });
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/orderManager.vue